<template>
	<div class="home_wrap">
<!-- 		<div class="red_top_bg">
			<div class="language" @click="$router.push('/language')">
				<img :src="require('../images/language/'+lang+'.png')">
			</div>
			<div class="top_title">
			</div>
			<div class="service " @click="$router.push('/notice')">
				<van-icon name="smile-comment" size="30"/>
			</div>
		</div> -->
		<div class="big_tit">
			<img class="slogo" height="20px" src="../images/login/slogo2.png" />
			<!-- <img class="logo" src="../images/index/logo1.png"  style="width: 100%;"/> -->
		</div>
	<!-- 	<div class="home_earnings" v-if="acc">
			<span>{{$t('shopds.allimcome')}}</span>
			<div >
				<img class="logo" src="../images/user/recharge1.png"  style="width: 20px;height: 20px;"/>
				<span style="font-weight: bold;font-size: 18px;margin: 0px 4px">{{acc.tong.allfee}}</span>
				<span style="font-size: 10px;">USDT</span>
			</div>
		</div> -->
		<div  class="lunbo-box">
		    <div  class="txtName">{{app?.web_name}}</div>
		    <div  class="txtMsg">{{$t('shopds.assistant')}}</div>
			<div class="bannerswip">
				<van-swipe :autoplay="3000" lazy-render >
				  <van-swipe-item  v-for="(item, index) in banner" :key="index">
					<img :src="item[lang]" style="width: 100%;"/>
				  </van-swipe-item>
				</van-swipe>
			</div>
		    <div  class="btn-box">
		        <button @click="$router.push('/grap')"  type="button"
		                class="van-button van-button--default van-button--normal van-button--round btn"
		                style="color: white; background: rgb(238, 38, 77); border-color: rgb(238, 38, 77);">
		            <div class="van-button__content"><span class="van-button__text">
					{{$t('shopd.graporder')}}
					</span>
					<i class="van-badge__wrapper van-icon van-icon-arrow van-button__icon"></i>
		            </div>
		        </button>
		    </div>
		</div>
		<!-- <div class="notice_content " v-if="cashes && cashes.length > 0" style="padding-left:3%;display: flex;height: 30px; overflow: hidden;margin: 2% auto;">
			<van-icon name="volume-o" size="20"/>
			<van-swipe style="padding-right: 1em;height: 1.8em;text-align: right;" :show-indicators="false" autoplay="1500"  :vertical="true">
			  <van-swipe-item v-for="i in cashes" style="line-height: 1.8em;font-size: 1em;" :key="i.id">
				 User[{{i.acc}}] made ${{i.money}} today
			  </van-swipe-item>
			</van-swipe>
		</div> -->
		<!-- <div class="home_module">
			<h3>{{$t('shopds.myservices')}}</h3>
			<div class="home_nav">
				<div>
					<div class="nav_content nav1" @click="$router.push('/about/27')">
						<div>
							<img src="../images/index/guanyuwomen_1.png" draggable="true">
							<p>{{$t('index.aboutUs')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
					<div class="nav_content nav2"  @click="$router.push('/download')">
						<div>
							<img src="../images/index/down.png" draggable="true">
							<p>{{$t('shopds.down')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
					<div class="nav_content nav3" @click="$router.push('/about')">
						<div>
							<img src="../images/index/query.png" draggable="true">
							<p>{{$t('shopds.help')}}</p>
						</div>
						<span class="uni-icons">
							 <img src="../images/user/arrow.png" > 
						</span>
					</div>
				</div>
				<div class="uni-badge--x">
					<div class="rightAll" @click="show_kefu=true;kefu_to();">
						<div class="module_right"><p>{{$t('shopds.custhelp')}}</p></div>
						<img src="../images/index/image5.png" draggable="true">
					</div>
				</div>
			</div>
		</div> -->
		
		<div class="shopList">
		    <div class="title">{{$t('shopds.selling')}}</div>
		    <div class="item"  v-for="(item, index) in pros" :key="index">
		        <div class="img-box"><img
		                    :src="item.img"
		                    alt=""></div>
		        <div class="right">
		            <div class="name">
						{{item.title}}
		            </div>
		            <div class="price line">
						<span class="lf">{{$t('shopds.price')}}</span>
					<span class="rt">${{item.price}}</span>
					</div>
		            <div class="daysales line">
						<span class="lf">{{$t('shopds.sale')}}</span>
						<span class="rt">${{item.sale}}</span>
						</div>
		            <div class="daygrowthrate line">
						<span class="lf">{{$t('shopds.growth')}}</span>
						<span class="rt">+{{item.raiserate}}%</span>
		            </div>
		        </div>
		    </div>
		    
		</div>

		<!-- <div class="txt-box">
		    <div class="title1">Trading assistant specially created for AliExpress</div>
		    <p class="txt1">AliExpress Shop trading assistant is an artificial intelligence trading platform
		        focusing on automatic transactions. Our platform integrates advanced algorithms and data analysis tools to help
		        users increase profits in the trading market.</p>
				<img class="icon-home03"
					src="data:image/png;base64,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" alt="">
		    <div class="title2">Intelligent artificial intelligence trading technology</div>
		    <p class="txt2">Use our advanced artificial intelligence technology to accurately analyze market
		        data and implement transactions, realize automated operations, and improve transaction efficiency.</p>
		        <img
		            class="icon-home03"
		            src="data:image/png;base64,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"
		            alt="">
		    <div class="title2">Diversity trading strategy</div>
		    <p class="txt2">We provide a variety of transaction strategies to meet the needs of different
		        users and adjust the strategies flexibly according to market changes.</p><img
		            class="icon-home03"
		            src="data:image/png;base64,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"
		            alt="">
		    <div class="title2">Stable risk management</div>
		    <p class="txt2">We are equipped with a strict risk control system to ensure the security and
		        stability of transactions and avoid unnecessary risks of user funds.</p>
		        <img class="icon-home03"
		            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABLCAYAAACGGCK3AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAcYSURBVHgB7Z1PbBRVGMC/Nzu7TbXb7rYBRbQsgSbVAFlPBJXQHkwEKxYOBrCGY1FIaC9qeqEcbIQLGMVwk0YSubWRCidiRSGRCwgGCCXpUqWAULpAsXT/zON9s50ybHdmZ+bNDLv0/ZJmdnfe7qbvt+/73vtmdhZAIBAYQ8BDlj643QQksIu9SRMIZkEJ9GdSU52J6IKE9phnQpbcv9MqSVIfCIqRTKen3tSkyPo9sfHhiByq3kkU0sFURXKP0kPpdGq33qIVApK0j4LAApFgsOIHtm3GO0+NkIaJu2fZJl7gSUmATPNQ1fxzYIHGyfFYNkuHQWCV5FBVbRRvSNojSyfGOqCwDISNFlmEH++IaDdmhBAgW4s8KaYmaYGnSLrb8WKNKSUxEHiKXkjSQnsrbQQcPJllUdoLhOw0bEkgkc0GBoGTrlAlVJvMtv9UMtCXScHrUgC2yhVmLwXfph/BdarABjkEKyXZsN0lJQu9mSkoB2b+i4As7VcU+iGlECvUkCi0NxGt5R4h77LOW0gk4wZpgD5IQZhJ2xg0F9KXTcH1rAIrAzJsNJF3JpsuGyEzPXO5MpqQJNJM2EjIa5OkQDuvhOu6QeA5T41zlMI2ixsmxuOKAjEmJ5mpgnMJUityh08UDLxDVVFcAFpaBApyTP5+Ch5duACTJ0+xexReOXIYnCCDwBGagIdHj8EU2yrJezP7Itu3gVOEEAso9+7B1Pm/mYQ/4H8mIl9APsH6enCKEFIAuwLykRe9Bk7xXcilbBauE8Vw/2W2ZkAesDh8JpsBM+7TXD0Z1yJmbS9Ov6YRmoCJgV9mRPDAM0I8OR5SLtXeqfMX4Na2HerWTVjVHOzCqr2qCwnmMBUrlkPks3Zwk4oVy4CHOS0EqW7bAvWnfwOppgbcgPd15rwQBEcKSpHrnSdj/WvxIIRME1xUD68eP8othSehI0KIDk0KTx4IiRziLiiFJ+wERA5xl1vbtsP9wz+BU0QOcRF+GXzhCilZIbh6fjhwDPyCVwbixtS5JIVg7ejaW2tgdFOb+pcZGQEvcUMGwhuukJITcrdnD4ysWgOZazkJOEr+XbveMyl2ZFQsX2Y6CninvEjJCEmzDseOH2NCZu1jcobfiEPywEFwE7sycEpstoAMPS85BDt6hIWoYlXW2190qX9u4ESGFKkxXUAGXMghz7Tai6PiVvsO2+XuXKf8zDrFWYhwKkMPjtobm9vUcr2GkyqvxjOv9mJusDIqCoGdgeHtITt+YQecuY2yTuSVgWgjJdy2OdfWhXCF+C4EOwXDDs6e7ByFyweljG76RJ0EWH1fVeJRa1PpytVvG8rQwAT/8sEDUNv1uWvVYl9DFp4YcJOFC20G5RYvtqyD+Xt7DEOYJsPqgahw2ybW0d+DHfC1eaa9WsjyRQh2CM6e3J4l6THKK37IcAPfcoi2yPNSBoIh7Nqqp9+nXGTo8VSIOp3VLfLsEtneDuGPN1tur+UnzCvlKAPxJGSdWPnRvpbQaAfP2Rvz9nzFhHyq3h7r+Zp18l7wilKQ4UkOudH4XqwiK/eNZCbj8eET4JSXDn6nHuvWg3JvtrMJwcg/4CalMjJczyF3lqxtrVCCZ4GQot/EMkKqqYaFLDHny0AqV7/DfTQvn1KRoYdbyHCsKTLW8ME+KaB+KTQCDgmyUgR2+Aus4w3bsJlU/emTXOfOapSiDITrzEUtRLHA53hUIJoMeZG1Usi8PT3qc8ZYXsHkbZdSlYE4HiF3lqzfyhuiELsyNDDhOzl1p5RlILaFPAlR9BBwhChEqxXZlaGh1ZNwpW4FLHGUsgzElhAMUTWh8FlCoAM44ZWhgVLwyzHY2Wbg/rquL6HUsSVEzsgxtokBJxg2ihXu7IKdveDIjwVDWLnIQHyv9uLqG8OGmzI0qlren3XwqJxkIL5+P8SPzsEQtvjiX2oJBdc15SQD8U2I359UnBqXI74I0delBOZ4LqRQXUpgjGdCMH4vYNNRs1KIYDbezLIikWSxupSgMB4IIYnjW1o2uHFa5VzE5ZBFEiQlNffuaAXIiktgOsG9EULJOZQRTfQnQOAYd0YIykirMsRVg5wx02/cI4QC7c2XMX2ZJ3E1IasQ0q/d5BohlNJv6oYGOgrvy3YSEvgVBOYQSKQl2K3ddSyEjYzdTEa30f6r4XmDjZPji5UM3c8acx3Eel6hEh1MS1J3IhdRVBwJUWVcMZahMR26WkFgGdtCqAKddVcH9oNAMBfw9PdD5jr/NayLy0TaxWJ8hLJFs5R+0BlNDJouDcQV5TwCzz+QFXWWGcGPPX7yabAqBtM/S2GEuHCARwQVuRvyz8ohpOn20pYms+cJIZ5BCp4iRSTzU6eEEI8gQApWKgIp2bSCIYR4hJSScEE8qH8MlwzFiq9iluUx442YM5QYPAr1i+KrQMDLY8X9/sEgbkk6AAAAAElFTkSuQmCC"
		            alt="">
		    <div class="title2">Professional user support</div>
		    <p class="txt2">Our professional team is ready to provide users with professional support at any
		        time. If you encounter any problems, our customer service team will help you in time.</p>
		</div> -->
	
		<div class="logos-box" style="padding-bottom: 60px;">
		    <div class="name">{{$t('item.partner')}}</div>
		    <div class="logos">
		        <div class="logo-box" v-for="ad in data.ad4">
					<img :src="ad[lang]">
				</div>
		    </div>
		</div>
<!-- 		<div class="ads_box" style="font-size: 16px;height: 40px;background-color: #ffffff;padding-top: 10px; padding-left: 10px;">
			<div class="items_tit" style="width: 100%;font-weight: bold;">
				{{$t('item.partner')}}
			</div>			
		</div>
		<div class="ads_box" style="background-color: #ffffff;flex-wrap: wrap;">			
			<div class="ads_img" v-for="ad in data.ad4" style="overflow:hidden;width:22%;min-height: 50px;float: left;margin-left: 5%;margin-right: 5%;margin-top:15px;">
				<a target="_blank" :href= "ad.url" style="width:100%;">
					<img style="width:100%;" :src="ad[lang]" alt="">
				</a>
			</div>
		</div> -->
		<van-popup 
		v-model="show"
		round 
		:style="{ 'line-height': '30px',
			'width': '70%',
			'padding': '15px',
			'font-weight': 'bold'}"
		>{{msg}}</van-popup>
		<van-dialog
		v-model="show_tc"
		:confirmButtonText="$t('utils.confirm')"
		>
		<div class="popup" v-html="tc_content"></div>
		</van-dialog>
		<div v-if="msg_show" class="kefu" :class="show_kefu?'':'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../images/shop2/kefu.jpg">
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"
	import { NoticeBar } from 'vant';
	Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Popup,
		Dialog,
		Field
	} from "vant";
	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Popup);
	export default {
		name: "Index",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_kefu: false,
				msg_show: true,
				loading: false,
				icon: [],
				data: {item1:{show:true},item2:{show:true},item3:{show:true}},
				app:{},
				islogin:false,
				isapp:false,
				show_img: false,
				show_tz:false,
				show_tc:false,
				tc_content:"",
				number: '',
				vips:null,
				vip:null,
				about:null,
				acc:null,
				msg:null,
				show:false,
				millionaire:null,
				philosophy:null,
				introduction:null,
				sku:[],
				banner:null,
				pros:null,
				articlessun:null,
				cashes:null,
				timer:null,
				coindatas:null,
				notifyStr:''
			};
		},
		created() {
			this.$parent.footer('index');
		},
		// beforeDestroy() {
		//     clearInterval(this.timer);
		// },
		mounted() {
		
			this.start();
			// this.accinfo();
			
		//	this.audioTitleScroll();
			//代理标识设置
			if(this.$router.history.current.query.agent){
				localStorage.setItem('agent', this.$router.history.current.query.agent);
			}
			//APP识别
			if(this.$router.history.current.query.isapp){
				localStorage.setItem('isapp', 'true');
			}
			this.isapp = localStorage.getItem('isapp')!=null;
			
			var that = this;
			document.body.addEventListener("scroll", function() {
				if (!that.show_kefu) {
					return;
				}
				that.show_kefu = false;
			}, false);
			document.addEventListener('click', function(ev) {
				if (ev.target.className != 'kefu_img') {
					that.show_kefu = false;
				}
			}, false);
		},
		methods: {
			upvip(it){
				this.$router.push('/invest');
				// if(this.vip){
				// 	if(this.vip.no < it.no){
				// 		Dialog.confirm({
				// 			title: this.$t('shopd.suretitle'),
				// 			confirmButtonText: this.$t('shopd.surebtn'),
				// 			cancelButtonText: this.$t('shopd.cancelbtn'),
				// 			message: this.$t('shopd.surec1')+it.price+ this.$t('shopd.surec2')+it.no+'?'
				// 		}).then(() => {
				// 		    Fetch('/user/upvip', {
				// 		      vip: it.id
				// 		    }).then((r) => {
				// 				if(r.code==1){
				// 					this.$router.push('/user');
				// 				}else{
				// 					this.$router.push('/invest');
				// 				}
								
				// 		    });
				// 		}).catch(() => {
						    
				// 		});
				// 	}
				// }else{
				// 	this.$router.push('/invest');
				// }
			},
			// accinfo() {
			// 	Fetch('/user/info').then((r) => {
			// 		this.acc = r.data;
			// 		this.vips= r.data.vips;
			// 		this.vip = r.data.vip;
			// 	});
			// },
			download(){
				let downloadurl = document.createElement('A');
				downloadurl.href = this.app.app_link;
				downloadurl.target = "blank";
				downloadurl.click();

			},
			kefu_to() {
				if (this.show_kefu) {
					var user = this.acc.user;
					var link = this.app.kefu_link + '&uid='+user.id+ '&name='+user.phone;
					window.location.href = link;
					// this.$router.push('/kefu');
				}
				this.show_kefu = !this.show_kefu;
			},
			hideDown() {
				this.show_img = false;
				this.$store.commit('setShowAdvert', false);
			},
			start() {
				Fetch('/index/int').then((r) => {
					this.data = r.data;
					this.vip = r.data.vip;
					this.vips= r.data.vips;
					this.banner = r.data.banner;
					
					this.cashes = r.data.cashes;
					this.articlessun = r.data.articlessun;
					var articles = r.data.articles;
					if(articles){
						for (let i = 0; i < articles.length; i++) {
							if(articles[i].keyword=='about'){
								this.about = articles[i];
							}else if(articles[i].keyword=='millionaire'){
								this.millionaire = articles[i];
							}else if(articles[i].keyword=='philosophy'){
								this.philosophy = articles[i];
							}else if(articles[i].keyword=='introduction'){
								this.introduction = articles[i];
							}
							
						}
					}
					
					this.loading = true;
					if(r.data.popup.show==1){
						this.tc_content = r.data.popup.content;
						if(localStorage.getItem('tc')!=this.tc_content){
							localStorage.setItem('tc',this.tc_content);
							this.show_tc = true;
						}
					}
				});
				Fetch('/user/basicinfo').then((r) => {
					this.acc = r.data;
					this.pros = r.data.pros;
				});
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
					this.notifyStr = this.app.notice;
				});
				this.islogin = localStorage.getItem('token')!=null;
				setTimeout(()=>{
					this.sync();
				},2000)
			},
			onChange(index) {
				let els = this.$refs.dian.querySelectorAll("div");
				for (let i = 0; i < els.length; i++) {
					els[i].className = "";
				}
				els[index].className = "selected";
			},
			sync() {
				Fetch("/index/sync", {}, null, false).then((r) => {
					var data = r.data;
					if(data && data.length>0){
						this.msg = data[0].content;
						this.show= true;
						setTimeout(()=>{
						  Fetch('/user/notice_view', {
						  	id: data[0].id
						  }).then(res => {
						  })
						},2000);
					}
				});
			},
			buy(item){
				this.sku = item;
				this.show_tz = true;
			},
			confirm(){
				Fetch("/index/item_apply", {
				  id: this.sku.id,
				  money:this.number
				}).then(r => {
					if (r.data && r.data>0) {
						this.$router.push("/invest/trx/"+r.data);
						
					} else {
						this.$router.push("/order");
					}
				  
				}).catch(err=>{
				    this.psd_val = '';
				})
			},
		   audioTitleScroll() { 
				var audio_title = $(".wrap");
				audio_title.each(function() {
					titleScroll(this);
				});

				function titleScroll(wrap) {
					var div = wrap.getElementsByTagName('div')[0];
					var span = div.getElementsByTagName('span')[0];
					var span_w = 1000;
					if (span) {
						span_w = span.offsetWidth;
					}
					var div_w = wrap.offsetWidth;
					if (div_w > span_w || div.getElementsByTagName('span').length >= 2) {
						// console.log(777);
						return false;
					}
					// console.log(666);
					div.innerHTML += div.innerHTML;
					var timer = setInterval(goLeft, 20);
					$(wrap).hover(function() {
						clearInterval(timer);
					}, function() {
						timer = setInterval(goLeft, 20);
					});

					function goLeft() {
						if (span_w <= wrap.scrollLeft) {
							wrap.scrollLeft -= span_w;
						} else {
							wrap.scrollLeft++;
						}
					}
				}
			}
		}
	};
</script>
<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.home_wrap {
		width: 100%;
		min-height: 100vh;
	}
	.red_top_bg{
		.language{
			position: absolute;
			top: 4px;
			left: 5px;
			height: 36px;
			img{
				height: 100%;
			}
		}
		.msg{
			position: absolute;
			top: 5px;
			right: 45px;
			height: 30px;
			
			img{
				height: 100%;
			}
		}
		.service{
			position: absolute;
			top: 5px;
			right: 6px;
			height: 30px;
			img{
				height: 100%;
			}
		}
		.top_title{
			text-align: center;
			font-size: 24px;
			display: block;
			height: 44px;
			line-height: 44px;
		}
	}
	.langbar {
		position: relative;
	    margin-top: 44px;
		padding-top: 8px;
		height: 56px;
		background-color: #fff;

	}
    .search_box {
        width: 90%;
        height: 32px;
        background-color: #f6f6f6;
        border-radius: 17px;
		border: solid 1px #1989fa;
        margin: 8px auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 0 10px 0 14px;

        .fdj {
            width: 16px;
            height: 16px;
            background: url(../images/item/fdj.png) no-repeat center center;
            background-size: 100% 100%;
        }

        .search_inp {
            flex: 1;
            margin: 0 8px;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            height: 20px;
        }

        .clear_inp {
            width: 20px;
            height: 20px;
            background: url(../images/item/clear.png) no-repeat center center;
            background-size: 100% 100%;
        }
    }

	.swiper-container {
		width: 100%;
		height: 120px;
		background: none;
		margin-top: 5px;
		.van-swipe-item {
			overflow: hidden;
		}

		a {
			float: left;
			width: 100%;
			height: 100%;
		}

		img {
			border-radius: 6px;
			margin-left: 2%;
			height: 100%;
			width: 96%;
		}
	}
	.work_box {
		background: #FFFFFF;
		padding: 17px 8px 4px 8px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		border-radius: 16px;
    	margin: 8px 8px;
		.item {
			width: 25%;
			text-align: center;
			margin-bottom: 10px;
			.item_img {
				width: 100%;
				border-radius: 5px;
				overflow: hidden;
				img {
					width: 44px;
					height: 44px;
				}
			}

			.item_title {
				width: 100%;
				line-height: 14px;
				font-size: 12px;
				color: #333333;
				text-align: center;
				transform: scale(0.85);
			}
		}
	}

	.work_box.query {
		.item {

			.item_img {
				border-radius: 5px;
				background: #f0f0f0;
			}

			.item_title {
				width: 100%;
				height: 14px;
				margin-left: 0;
				background: #f0f0f0;
			}
		}

	}
	.ads_box_1{
		border-radius: 13px;
		margin-top: 10px;
		text-align: center;
		img{
			width: 95%;
		}
	}
	.ads_box{
		// background: rgba(255, 255, 255, 1);
		width: 97%;
		border-radius: 5px;
		margin:5px auto 0 auto;
		display: flex;
		text-align: center;
		.ads_img{

		}
		img{
			width: 96%;
			border-radius: 5px;
		}
	}
	.items_1,
	.items_2,
	.items_3
	{
		margin: 10px 2% 0 2%;
		width: 96%;
		.items_tit {
      overflow: hidden;
			border-radius: 5px 5px 0 0 ;
			height: 44px;
			line-height: 44px;
			font-size: 16px;
			color: rgba(0, 0, 0, .8);
			background: #FFFFFF;
			border-bottom: 1px solid #F7F7F7;
			padding: 0 14px;
			display: flex;
			justify-content: space-between;
			.tit_tip{
				display: contents;
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;
				margin-left: 10px;
			}
			.tit_more{
				font-size: 12px;
				font-weight: normal;
				color: #b2b2b2;

			}
		}
		.item{
			background: #FFFFFF;
		}
	}
	.items_1 {
		.item{
			padding: 5px;
			margin: 0 0 10px 0;
			div{
				margin: 20px 0;
			}
			.item_tit{
				text-align: center;
				overflow: hidden;
				p{
					text-overflow:ellipsis;
					white-space: nowrap;
					font-weight: bold;
					font-size: 16px;
				}
			}
			.item_rate{
				text-align: center;
				color: #FF0000;
				font-size: 22px;
				font-weight: bold;
			}
			.item_desc{
				p{
					width: 50%;
					text-align: center;
				}
			}
			.item_btn{
				text-align: center;

				button{
					margin: auto;
					width: 60%;
					min-width: 60px;
					background: #e7544d;
					color: #FFFFFF;
					padding: 10px 0px;
					border-radius: 10px;
				}
				.item_btn_over{
					background: #999;
				}
			}
		}
	}
	.items_2 {
		.item{
			display: flex;
			width: 100%;
			text-align: center;
			border-bottom: 1px solid #ECECEC;
			div{
				margin: 15px 0;
			}
			.item_rate{
				width: 20%;
				p{
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_tit{
				width: 55%;
				p{
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;
					padding: 5px 0;
				}
				p:nth-child(1){
					font-weight: bold;
				}
				p:nth-child(2){
					color: #999;
					font-size: 12px;
				}
			}
			.item_btn{
				width: 25%;
				button{
					min-width: 60px;
					margin-top: 12px;
					color: #1989fa;
					padding: 5px 5px;
					border-radius: 5px;
					border: 1px solid #1989fa;
				}
				.item_btn_over{
					color: #999;
					border: 1px solid #999;
				}
			}
		}
	}
	.items_3 {
		.item{
			margin-bottom: 10px;
			div{
				margin: 5px 0;
			}
			.item_div1{
				display: flex;
				justify-content: space-between;
				border-bottom: 1px solid #ECECEC;
				padding: 15px 10px;
				p:nth-child(1){
					// width: 70%;
					font-weight: bold;
					overflow:hidden;
					text-overflow:ellipsis;
					white-space:nowrap;

				}
				p:nth-child(2){
					color: green;
					font-size: 12px;
				}
			}
			.item_div2{
				display: flex;
				justify-content: space-between;
				text-align:center;
				font-size: 14px;
				div{
					width: 33.33%;
					p{
						padding: 5px 0;
					}
				}
				.item_rate{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_day{
					p:nth-child(1){
						font-weight: bold;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
				.item_min{
					p:nth-child(1){
						font-weight: bold;
						color: red;
					}
					p:nth-child(2){
						color: green;
						font-size: 12px;
					}
				}
			}
			.item_div3{
				color: #999;
				padding: 5px 10px;
			}
			.item_div4{
				padding: 5px 10px;
				display: flex;
				justify-content: space-between;
				div:nth-child(1){
					width: 75%;
					margin-top: 16px;
				}
				.item_btn{
					width: 20%;
					button{
						min-width: 60px;
						color: #1989fa;
						padding: 5px 5px;
						border-radius: 5px;
						border: 1px solid #1989fa;
					}
					.item_btn_over{
						color: #999;
						border: 1px solid #999;
					}
				}
			}
		}
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 60vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}

	.wrap {
		padding-top: 10px;
		overflow: hidden;
		width: 150px;
		cursor: pointer;
	}

	.scroll {
		width: 1200px;
		height: 30px;
		line-height: 30px;
		overflow: hidden;
	}
			
	.items_1 .item div.item_desc{
		color: #bec3ce;
		font-size: 12px;
		margin: 10px;
	}
	.notice-swipe {
		height: 40px;
		line-height: 40px;
	}
	.items_1 .item .item_btn button{
	    border-radius: 5px;
	}
	.main_problem{
		overflow: hidden;
		margin-bottom: 0px;
		padding: 10px;
		background-color: #FFFF;
		padding-bottom: 0px;
	}
	.alcenter {
	    align-items: center;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft26 {
	    font-size: 13px;
	}
	.mb10 {
	    margin-bottom: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.main_problem img{
	    width: 60px;
	    height: 60px;
		display: inline-block;
		overflow: hidden;
		position: relative;
	}
	.main-content{
	    overflow: hidden;
	    width: 100%;
	    background: none;
	    padding: 10px 8px;
	    box-sizing: border-box;
	}
	.flex-between {
	    display: flex;
	    justify-content: space-between!important;
	}
	.main-content .link_box .label{
	    width: 48%;
	    height: 180px;
	    background-color: #fff;
	    border-radius: 10px;
	    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
	    padding-top: 18px;
	    box-sizing: border-box;
	}
	.main-content .link_box .label>div:nth-child(1){
		display: block;
		width: 87px;
		height: 66px;
		margin: 0 auto 5px;
		overflow: hidden;
		position: relative;
		div{
			width: 100%;
			height: 100%;
		}
		img{
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
	.flex-center {
		justify-content: center;
		align-items: center;
		text-align: center;
		margin-top: 25px;
		line-height: 20px;
	}
	.font-bold {
	    font-weight: 700;
	}
	.ft36 {
	    font-size: 18px;
	}
	.c_48a093 {
	    color: #48a093;
	}
	.ml10 {
	    margin-left: 5px;
	}
	.c_2a2a2a {
	    color: #2a2a2a;
	}
	.main_join{
	    overflow: hidden;
	    width: 100%;
	    background-color: #fff;
	    padding: 22px 17px 28px;
	    text-align: center;
	    box-sizing: border-box;
		border-radius: 5px;
		.btn{
		    width: 159px;
		    height: 34px;
		    border-radius: 20px;
		    font-size: 16px;
		    font-weight: 700;
		    color: #fff;
		    background: linear-gradient(270deg,#4caa8e,#5bc878);
		    margin: 16px auto 0;
		    overflow: hidden;
		}
		.flex-center {
		    display: flex;
		    justify-content: center;
		    align-items: center;
		}
		img{
			width: 258px;
		}
		div:nth-child(3){
			height: auto;
			margin: 15px auto 0;
			img{
				width: 100%;
			}
		}
	}
	.ft40 {
	    font-size: 20px;
	}
	.text-center {
	    text-align: center;
	}
	.mb30 {
	    margin-bottom: 15px;
	}
	.main_join .des{
	    text-align: left;
	    margin: 0 auto;
	    line-height: 18px;
	}
	.ft20 {
	    font-size: 10px!important;
	}
	.c_9696a1 {
	    color: #9696a1;
	}
	.main_display{
	    margin-top: 35px;
	    overflow: hidden;
		.h3{
		    font-size: 20px;
		    font-weight: 700;
		    color:#FFFFFF;
		    text-align: center;
		    margin-bottom: 20px;
		}
		#box{
		    width: 100%;
		    margin-top: 54px;
			.item{
			    position: relative;
			    width: 48%;
			    height: 136px;
			    background-color: #fff;
			    border-radius: 10px;
			    padding-top: 59px;
			    box-shadow: 0 10px 20px 0 rgb(185 212 205 / 25%);
			    box-sizing: border-box;
				div:nth-child(1){
				    width: 75px;
				    height: 75px;
				    position: absolute;
				    left: 30%;
				    top: -33px;
					img{
						height: 100%;
					}
				}
				div:nth-child(2),div:nth-child(4){
					display: block;
					text-align: center;
					font-size: 12px;
					line-height: 1.1;
					color: #2a2a2a;
					margin-bottom: 10px;
				}
				div:nth-child(3){
					text-align: center;
					font-size: 20px;
					color: #02a393;
					line-height: 20px;
					font-weight: 600;
					margin-bottom: 10px;
				}
			}
		}
	}
	.main_about{
	    width: 100%;
	    overflow: hidden;
	    background-color: #fff;
	    border-radius: 10px;
	    margin-top: 28px;
	    padding: 21px 0 54px;
	    box-sizing: border-box;
		.about {
			.title{
			    text-align: center;
			    font-size: 20px;
			    font-weight: 700;
			    margin-bottom: 14px;
			    color: #2a2a2a;
			}
			div:nth-child(2){
				display: block;
				text-align: center;
				font-size: 16px;
				color: #2a2a2a;
				margin-bottom: 18px;
			}
			.content{
			    padding: 0 34px;
			    font-size: 10px;
			    color: #9696a1;
			    line-height: 16px;
			}
			div:nth-child(4){
				display: block;
				width: 280px;
				height: 164px;
				margin: 35px auto 0;
				img{
					height: 100%;
				}
			}
		}
	}
	.banner {
	   height: 52px;
	   display: flex;
	   width: 100%;
	   background: none;
	   background-size: 100% 100%;
	   position: relative;
	   flex-direction: column;
		p {
		    padding: 67px 0 0 52px;
		    font-size: 15px;
		    color: #b4ffec;
		    font-weight: 500;
		}
		>div {
		    padding: 10px 0 0 52px;
			color: #fff;
			font-size: 24px;
			font-weight: 700;
			position: relative;
			display: flex;
			z-index: 2;
			align-items: center;
			>span {
			    font-size: 16px;
			    margin-left: 5px;
			}
		}
		.notice {
			height: 52px;
			padding: 0;
			font-size: 14px;
			font-weight: 400;
			display: block;
			width: 100%;
			background: linear-gradient(270deg, #ee264d, #746b0a);
			.icon {
			    width: 45px;
			    height: 45px;
			    line-height: 48px;
			    text-align: center;
			    position: absolute;
			    left: 0;
			    top: 1px;
				img {
				    width: 40px;
				    position: absolute;
				    top: 8px;
				    left: 8px;
				}
			}
			.text {
			    position: absolute;
			    left: 48px;
			    top: 1px;
			    right: 0;
			    line-height: 48px;
			}
		}
	}
	.tabs {
	    display: flex;
	    padding-top: 14px;
	    flex-direction: column;
		>ul {
		    list-style: none;
		    margin: 0;
		    padding: 0;
		    text-align: center;
			>li {
			    width: 33.33333%;
			    float: left;
			    background: none;
			    padding-bottom: 10px;
				>img {
				    width: 75%;
				    height: 75%;
				    margin: auto;
					height: 68px;
				}
				>p {
				    font-weight: 600;
				    font-size: 13px;
				    padding-top: 5px;
				    color: #fff;
				}
			}
		}
	}
	
	.game-list{
		.game-item {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    height: 50px;
		}
		.icon {
		    margin-right:10px;
		    width: 23px;
		    height: 23px;
		    border-radius: 100%;
		    overflow: hidden;
			img {
			    display: block;
			    width: 100%;
			    height: 100%;
			}
		}
		.title {
		    display: block;
		    font-size: 14px;
		}
		.info {
		    width: 119px;
		    line-height: 1;
		    text-align: left;
		}
		.time {
		    color: #ababab;
			font-size: 12px;
		}
		.price.mine-rise {
		    color: #17cdaf;
		}
		.price.mine-fall {
		    color: #f85963;
		}
		.price {
		    flex: 1;
		    font-size: 16px;
		    font-weight: 700;
		    text-align: right;
		    padding-right: 10px;
		}
		 .zd.mine-rise {
		    background: #17cdaf;
		}
		.zd {
		    display: block;
		    width: 79px;
		    height:27px;
		    background-color: #f85963;
		    border-radius: 5px;
		    line-height: 27px;
		    text-align: center;
		    font-size:14px;
		    color: #fff;
		}
	} 
	.notice_content{
		overflow: hidden;
		transition: top .5s;
		.notice_list {
			padding: 0;
		}
		.notice_item {
		    display: flex;
		    justify-content: space-between;
		    font-size: 14px;
		    height: 30px;
		    line-height: 30px;
			div{
			}
		}
		.gray {
			font-size: 12px;
			color: #ababab;
		}
	}
	.swiper-wrapper {
	    position: relative;
	    width: 100%;
	    height: 100%;
	    z-index: 1;
	    display: flex;
	    transition-property: transform;
	    box-sizing: content-box;
		.swiper-slide {
		    flex-shrink: 0;
		    width: 100%;
		    height: 100%;
		    position: relative;
		    transition-property: transform;
		}
		.van-swipe-item {
		    display: flex;
		}
		.item-left {
		    margin-right: 20px;
			img {
				overflow: hidden;
				width: 60px;
				height: 60px;
				border-radius: 100%;
				border: 5px solid #eee;
			}
		}
		.item-body {
		    flex: 1;
			text-align: left;
			line-height: 16px;
			color: #8a9089;
		}
		.people-content {
		    margin:5px 0 10px;
		    color: #8a9089;
		    font-size: 12px;
		}
		.people-name {
			font-size: 14px;
			color: #656b64;
			font-weight: 700;
		}
	}
	.ads_box{
		.items_tit{
			margin-bottom: 25px;
		}
	}
	
	
	.vip-item {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: justify;
	    -webkit-justify-content: space-between;
	    -ms-flex-pack: justify;
	    justify-content: space-between;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    padding: 2vw 3vw;
	    box-sizing: border-box;
	    border-radius: 8px;
	    background-color: #fff;
	    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
	    margin-bottom: 12px;
	    position: relative;
	    overflow: hidden;
	}
	.vip-item .vip-img {
	    width: 20vw;
	    height: 20vw;
	}
	.vip-item .vip-info {
	    text-align: left;
		width: 50vw;
	}
	.vip-item .vip-info .vip-name {
	    font-size: 3.8vw;
	    font-weight: bold;
	    color: #222;
		margin-bottom: 1vw;
		margin-top: 8vw;
	}
	.vip-item .vip-info .vip-desc {
		font-size: 3vw;
		font-weight: bold;
		color: #999;
		line-height: 1.5em;
	}
	.vip-item .action-box .ord{
		font-size: 2vw;
		font-weight: bold;
		line-height: 6vw;
		color: rgb(74, 193, 171);
	}
	.vip-item .action-box .i-icon {
	    padding: 2vw 3vw;
	    text-align: center;
	    background-color: #ee264d;;
	    font-size: 14px;
	    color:#fff;
	    border-radius: 1.5em;
	    cursor: pointer;
	}
	
	.vip-item .absoulte-level {
	    position: absolute;
	    background: #f5f5f5;
	    color: #ee264d;;
	    padding: 24px 16px 8px 16px;
	    border-radius: 50%;
	    top: -20px;
	    left: 50%;
	    font-size: 12px;
	}
	.vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	.vip-item .mask {
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 100%;
	    background: rgba(0,0,0,.4);
	    border-radius: 8px;
	    z-index: 2;
	}
	
	.vip-item .mask .lock-box,.index-wrap2 .vip-item .mask{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	}
	
	.vip-item .mask .lock-box {
	    background: hsla(0,0%,100%,.4);
	    width: 50px;
	    height: 50px;
	    border-radius: 50%;
	}
	.vip-item .mask .lock-box, .index-wrap2 .vip-item .mask{
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center;
	}
	 .my-swipe .van-swipe-item {
	    
	  }
	  .item_title{
	  	font-size: 1.3em;
	  	font-weight: bold;
	  	line-height: 6vw;
	  	margin-top: 2vw;
	  }
	.bannerswip{
		width: 90%;
		height: auto;
		margin-left: 5%;
		border-radius: 10px;
		margin: 0.85333rem auto 0;
		img{
			border-radius: 10px;
		}
	}
	.home_earnings{
	    width: 90%;
	    height: 41px;
	    margin: 3% 5%;
	    border-radius: 10px;
	    display: flex;
	    justify-content: space-between;
	    align-items: center;
	    padding: 0 10px;
	    background-color: #ee264d;;
	    font-size: 15px;
		div{
			min-width: 40%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.notice_content{
		width: 90%;
		margin: 2% 5%;
		height: 36px;
		background-color: #ee264d;;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 5px;
		.name{
			width: 50vw;
			display: block;
		}
		.value{
			width: 50vw;
			display: block;
		}
	}
	.home_module{
	    width: 90%;
	    margin: 0 5%;
	    color: #232f3e;
		h3{
		    height: 30px;
			display: block;
			font-size: 18px;
			margin-block-start: 1em;
			margin-block-end: 1em;
			margin-inline-start: 0px;
			margin-inline-end: 0px;
			font-weight: bold;
			margin-bottom: 0;
		}
		.module2_content{
		    width: 100%;
		    height: 130px;
		    display: flex;
		    justify-content: space-between;
		    flex-wrap: wrap;
		    align-items: center;
			img{
				height: 100%;
				border-radius: 10px;
				margin: 2% 0;
			}
			a{
				width: 14.3%;
				height: 38%;
				border-radius: 10px;
				margin: 2% 0;
			}
		}
		.home_nav{
		    width: 100%;
		    height: 140px;
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		    font-size: 15px;
			>div:first-child {
			    width: 48%;
			    height: 100%;
			    display: flex;
			    flex-direction: column;
			    align-items: center;
			    justify-content: space-between;
				.nav1{
				    background-color: #f4e1ff;
				}
				.nav2{
				    background-color: #ffd9e7;
				}
				.nav3{
				    background-color: #feeba9;
				}
				.nav_content{
				    width: 100%;
				    height: 30%;
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    border-radius: 5px;
				    padding: 5px;
					>div:first-child {
					    width: 70%;
					    display: flex;
					    align-items: center;
					}
					.uniui-forward:before {
					    content: "\e660";
					}
					.uni-icons {
					    font-family: uniicons;
					    text-decoration: none;
					    text-align: center;
						img{
							height: 18px;
							width: 18px;
						}
					}
					img{
					    width: 26px;
					    height: 26px;
					}
					p{
					    margin-left: 3%;
					}
				}
			}
			>div:last-child {
				width: 48%;
				height: 100%;
				display: flex;
				border-radius: 5px;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				background-color: #c3cdff;
				.rightAll{
				    position: relative;
				    box-sizing: border-box;
				    width: 100%;
				    height: 100%;
					.module_right{
					    width: 100%;
					    padding: 0 5px;
					    display: flex;
					    justify-content: space-between;
					    align-items: center;
					    margin: 3% 0;
					}
					img{
					    width: 100%;
					    height: 70%;
					}
				}
			}
		}
	}
	
	.txt-box{
	    width: 100%;
	    padding: 0 .53333rem;
	    margin: 1.22667rem auto 0;
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-orient: vertical;
	    -webkit-box-direction: normal;
	    -webkit-flex-direction: column;
	    -ms-flex-direction: column;
	    flex-direction: column;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center
	}
	
	.txt-box .title1{
	    color: #000;
	    text-align: center;
	    font-size:  .53333rem;
	    font-weight: 700;
	    line-height: 1.06667rem
	}
	
	.txt-box .txt1{
	    margin-top: .66667rem;
	    color: #000;
	    text-align: center;
	    font-size: .42667rem;
	    font-weight: 400;
	    line-height: .66667rem;
	    margin-bottom: .8rem
	}
	
	.txt-box .icon-home03{
	    width: 1.33333rem;
	    margin-top: 1.33333rem
	}
	
	.txt-box .title2{
	    color: #000;
	    text-align: center;
	    font-size: .53333rem;
	    font-weight: 700;
	    margin: .26667rem 0
	}
	
	.txt-box .txt2{
	    color: #000;
	    text-align: center;
	    font-size: .37333rem;
	    font-weight: 400;
	    line-height: .58667rem
	}
	
	.logos-box{
	    width: 100%;
	    background: #000;
	    padding: .53333rem
	}
	
	.logos-box .name{
	    color: #fff;
	    text-align: center;
	    font-size: .58667rem;
	    font-weight: 700;
	    margin-bottom: .74667rem
	}
	
	.logos-box .logos{
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-flex-wrap: wrap;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	    -webkit-justify-content: space-around;
	    -ms-flex-pack: distribute;
	    justify-content: space-around
	}
	
	.logos-box .logos .logo-box{
	    width: calc(50% - .42667rem);
	    height: 1.28rem;
	    border-radius: .13333rem;
	    background: #fff;
	    margin-bottom: .42667rem;
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center
	}
	
	.logos-box .logos .logo-box img{
	    width: 2.90667rem
	}
	.logos-box {
	    width: 100%;
	    background: #000;
	    padding: .53333rem
	}
	
	.logos-box .name {
	    color: #fff;
	    text-align: center;
	    font-size: .58667rem;
	    font-weight: 700;
	    margin-bottom: .74667rem
	}
	
	.logos-box .logos {
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-flex-wrap: wrap;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	    -webkit-justify-content: space-around;
	    -ms-flex-pack: distribute;
	    justify-content: space-around
	}
	
	.logos-box .logos .logo-box {
	    width: calc(50% - .42667rem);
	    height: 1.28rem;
	    border-radius: .13333rem;
	    background: #fff;
	    margin-bottom: .42667rem;
	    display: -webkit-box;
	    display: -webkit-flex;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-align: center;
	    -webkit-align-items: center;
	    -ms-flex-align: center;
	    align-items: center;
	    -webkit-box-pack: center;
	    -webkit-justify-content: center;
	    -ms-flex-pack: center;
	    justify-content: center
	}
	
	.logos-box .logos .logo-box img {
	    width: 2.90667rem
	}
	.txt-box{
	    padding: 0.53333rem 0.42667rem;
	}
	
	.shopList {
	    border-radius: .13333rem;
	    overflow: hidden;
	    width: 100%;
	    border: .02667rem solid #000;
		width: 94%;
		margin: 10px auto;
	    .title {
	        line-height: 1.06667rem;
	        background: #000;
	        color: #fff;
	        font-size: .42667rem;
	        font-weight: 700;
	        text-align: center
	    }
	    
	    .item {
	        display: -webkit-box;
	        display: -webkit-flex;
	        display: -ms-flexbox;
	        display: flex;
	        -webkit-box-align: center;
	        -webkit-align-items: center;
	        -ms-flex-align: center;
	        align-items: center;
	        -webkit-box-pack: justify;
	        -webkit-justify-content: space-between;
	        -ms-flex-pack: justify;
	        justify-content: space-between;
	        padding: .32rem;
	        border-top: .02667rem solid #000
	    }
	    
	    .item .img-box {
	        width: 2.66667rem;
	        height: 2.66667rem;
	        display: -webkit-box;
	        display: -webkit-flex;
	        display: -ms-flexbox;
	        display: flex;
	        -webkit-box-align: center;
	        -webkit-align-items: center;
	        -ms-flex-align: center;
	        align-items: center;
	        -webkit-box-pack: center;
	        -webkit-justify-content: center;
	        -ms-flex-pack: center;
	        justify-content: center;
	        margin-right: .21333rem;
	        overflow: hidden;
	        border-radius: .13333rem
	    }
	    
	    .item .img-box img {
	        width: 100%
	    }
	    
	    .item .right {
	        -webkit-box-flex: 1;
	        -webkit-flex: 1;
	        -ms-flex: 1;
	        flex: 1
	    }
	    
	    .item .right .name {
	        height: .93333rem;
	        color: #000;
	        font-size: .37333rem;
	        font-weight: 700;
	        display: -webkit-box;
	        -webkit-box-orient: vertical;
	        overflow: hidden;
	        -webkit-line-clamp: 2;
	        line-clamp: 2;
			line-height: .4666rem;
	    }
	    
	    .item .right .line {
	        display: -webkit-box;
	        display: -webkit-flex;
	        display: -ms-flexbox;
	        display: flex;
	        -webkit-box-align: center;
	        -webkit-align-items: center;
	        -ms-flex-align: center;
	        align-items: center;
	        -webkit-box-pack: justify;
	        -webkit-justify-content: space-between;
	        -ms-flex-pack: justify;
	        justify-content: space-between;
	        color: #333;
	        font-size: .37333rem;
	        font-weight: 500;
	        margin-top: .16rem
	    }
	    
	    .item .right .daygrowthrate .rt {
	        color: #00a006
	    }
	}
	.big_tit {
	    font-size: 16px;
	    font-weight: 500;
	    line-height: 25px;
	    padding: 10px;
		display: block;
		position:relative;
		top: auto;
		height: 40px;
		background-color: #000;
	}
	.lunbo-box{
	    width: 100%;
	    height: 10.8rem;
	    background-color: #000;
	    padding-top: .50667rem;
	    .txtName{
	        color: #ee264d;
	        text-align: center;
	        font-size: .8rem;
	        font-weight: 700
	    }
	    
	    .txtMsg{
	        color: #fff;
	        font-size: .66667rem;
	        font-weight: 700;
	        text-align: center
	    }
	    
	    .my-swipe{
	        width: calc(100% - .85333rem);
	        height: 3.92rem;
	        margin: .85333rem auto 0;
	        border-radius: .26667rem
	    }
	    
	    .my-swipe .van-swipe-item{
	        width: calc(100% - .85333rem);
	        color: #fff;
	        font-size: .53333rem;
	        line-height: 4rem;
	        text-align: center;
	        background-color: #393939
	    }
	    
	    .my-swipe .van-swipe-item img{
	        width: 100%;
	        height: 100%
	    }
	    
	    .btn-box{
	        width: 6.02667rem;
	        margin: .96rem auto 0
	    }
	    
	    .btn-box .btn{
	        width: 100%;
	        height: 1.06667rem
	    }
	}
</style>
